module.exports = __webpack_public_path__ + "static/media/4.66e61986.jpg";